import PlayerWrapper from '@anm/components/PlayerWrapper';
import { WAVE_PROD } from '@anm/constants/domains';
import customizeTemplateInfo from '@anm/data/video-templates/customize-template-info';
import sleep from '@anm/helpers/sleep';
import useIntersectionObserver from '@anm/hooks/useIntersectionObserver';
import Head from 'next/head';
import { useEffect, useRef, FC } from 'react';

import { ContainerWrapper, PlayerContainer, Title } from './Wrapper';
import { usePauseVideoOnUnmount } from './hooks';

const playerSrc = `${WAVE_PROD}embed/player.js`;

const CustomizeTemplateInfo: FC = () => {
  const playerWrapperRef = useRef<HTMLDivElement>(null);

  usePauseVideoOnUnmount(playerWrapperRef);

  const [containerRef, inView] = useIntersectionObserver({
    rootMargin: '1000px 0px',
    triggerOnce: true
  });

  useEffect(() => {
    if (!inView) return;
    (async () => {
      await sleep(500);

      window.wavePlayer?.init?.();
    })();
  }, [inView]);

  return (
    <>
      {inView && (
        <Head key={playerSrc}>
          <script src={playerSrc} defer></script>
        </Head>
      )}
      <ContainerWrapper size={1040} ref={containerRef}>
        <Title color="black" level={3} {...customizeTemplateInfo} />
        <PlayerContainer ref={playerWrapperRef}>
          <PlayerWrapper
            previewSrc={null}
            {...{ playerWrapperRef }}
            videoName={customizeTemplateInfo.title}
            videoId={customizeTemplateInfo.videoId}
          />
        </PlayerContainer>
      </ContainerWrapper>
    </>
  );
};

export default CustomizeTemplateInfo;
